import React from "react";

const DeleteAccount = () => {
  return <div>DeleteAccount</div>;
};

export default DeleteAccount;
